// **** explorar empresas/categorias ****
// **** autor: Walcledson de Paula ****
// **** 08-06-24
// **** atualizado: 10/7/24w /IA 21h29 ****




import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import apiaxios from "../../../../Services/apiaxios.js";
import { apifetch } from "../../../../Services/apifecth.js";
import handleApiError from "../../../../Services/apiErrorHandler.js";
import { decrypt } from "../../../../Services/cryptoUtils.js";
import { autoLogout } from "../../../../Services/authutils.js";
import { Oval } from 'react-loader-spinner';
import Swal from "sweetalert2";
import Menu from "../../components/Menu/menu.jsx";
import BuscaEmpresa from '../../components/Busca/buscaempresa.jsx';
import Footer from "../../components/Footer/footer.jsx";
import Estrela0 from '../../../../Assets/Avaliacoes/0star.png';
import Estrela1 from '../../../../Assets/Avaliacoes/1star.png';
import Estrela2 from '../../../../Assets/Avaliacoes/2star.png';
import Estrela3 from '../../../../Assets/Avaliacoes/3star.png';
import Estrela4 from '../../../../Assets/Avaliacoes/4star.png';
import Estrela5 from '../../../../Assets/Avaliacoes/5star.png';

import './explorarempresas.css';

function ExplorarEmpresas() {
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    const tokenlg = localStorage.getItem("tokenlg");

    useEffect(() => {
        if (!tokenASW || !tokenlg) {
            console.error('token adulterado');
            autoLogout();
        }
    }, [tokenASW, tokenlg]);

    const getInitialUserData = () => {
        const encryptedUser = localStorage.getItem('tokenacw');
        if (encryptedUser) {
            try {
                const decryptedUser = decrypt(encryptedUser);
                return {
                    userId: decryptedUser.id_usuario || 0,
                    cidade: decryptedUser.cidade || '',
                    usu_ativa_conta: decryptedUser.ativa_conta || 0
                };
            } catch (error) {
                console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
                return { userId: 0, cidade: '', usu_ativa_conta: 0 };
            }
        }
        return { userId: 0, cidade: '', usu_ativa_conta: 0 };
    };

    const initialUserData = getInitialUserData();
    const [cidade, setCidade] = useState(initialUserData.cidade);
    const [user, setUser] = useState(initialUserData.userId);
    const [usu_ativa_conta, setUsu_ativa_conta] = useState(initialUserData.usu_ativa_conta);
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    // console.log('initialuserdata usu_ativa_conta ', usu_ativa_conta, 'initialuserdata ativa_conta ', initialUserData.usu_ativa_conta);
  
    const id_categoria = localStorage.getItem("id_categoria");
    const [empresa, setEmpresa] = useState('');
    const [nenhumaEmpresaEncontrada, setNenhumaEmpresaEncontrada] = useState(false);
    const [dados, setDados] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [mensagem, setMensagem] = useState('');
   
    useEffect(() => {
        if (!id_categoria) {
            Swal.fire({
                title: 'Atenção',
                text: 'Você precisa selecionar uma categoria primeiro, para depois explorar empresas!',
                icon: 'warning',
                confirmButtonColor: '#3085d6',
              }).then((result) => {
                if (result.isConfirmed) {
                  navigate('/app/cliente/home');    
                }
              });
            return;
        }
        atualizarEmpresas(empresa);
    }, [cidade, id_categoria, empresa]);

    const atualizarEmpresas = (empresaNome) => {
        const url = `/empresa/listarWeb?token=${tokenASW}&id_usuario=${user}&cidade=${encodeURIComponent(cidade)}&id_categoria=${id_categoria}&busca=${encodeURIComponent(empresaNome)}`;
        setLoading(true);
        apiaxios.get(url)
            .then((response) => {
                // setLoading(false);
                if (response.data.retorno) {
                    alert('Erro ao listar empresas: ' + response.data.retorno);
                } else {
                    if (response.data.length === 0) {
                        setNenhumaEmpresaEncontrada(true);
                    } else {
                        setNenhumaEmpresaEncontrada(false);
                        setDados(response.data);
                        fetchFotos(response.data);
                        fetchAvaliacoes(response.data);
                    }
                }
            }).catch(error => {
                // setLoading(false);
                handleApiError(error);
            }).finally (
                setLoading(false)
            )
    };

    const fetchFotos = (empresasFotos) => {
        const promises = empresasFotos.map(async (empresa, index) => {
            try {
                const fotoResponse = await apiaxios.get(`/empresa/FotoPerfilMini?id_empresa=${empresa.ID_EMPRESA}`);
                if (fotoResponse.data.retorno === "OK" && fotoResponse.data.foto) {
                    empresa.foto64mini = `data:image/jpeg;base64,${fotoResponse.data.foto}`;
                }
            } catch (error) {
                handleApiError(error);
            } finally {
                // Update the state with the new data including the photo
                setDados(prevDados => {
                    const newDados = [...prevDados];
                    newDados[index] = empresa;
                    return newDados;
                });
            }
        });
        return Promise.all(promises);
    };

    const fetchAvaliacoes = (empresasAvaliacoes) => {
        const promises = empresasAvaliacoes.map(async (empresa, index) => {
            try {
                const avaliacaoResponse = await apiaxios.get(`/Reserva/AvaliacaoMedia?id_usuario=${empresa.ID_EMPRESA}&tipo_avaliacao=P`);
                if (avaliacaoResponse.data.retorno === "OK") {
                    empresa.AVALIACAO_MEDIA = parseInt(avaliacaoResponse.data.avaliacao_media, 10);
                    empresa.AVALIACAO_TOTAL = parseInt(avaliacaoResponse.data.avaliacao_total, 10);
                }
            } catch (error) {
                handleApiError(error);
            } finally {
                // Update the state with the new data including the evaluation
                setDados(prevDados => {
                    const newDados = [...prevDados];
                    newDados[index] = empresa;
                    return newDados;
                });
            }
        });
        return Promise.all(promises);
    };

    const getStarImage = (rating) => {
        switch (rating) {
            case 0:
                return Estrela0;
            case 1:
                return Estrela1;
            case 2:
                return Estrela2;
            case 3:
                return Estrela3;
            case 4:
                return Estrela4;
            case 5:
                return Estrela5;
            default:
                return Estrela0;
        }
    };

    const CarregaEmpresa = async (id_empresa, nome_empresa, endereco_empresa, fone_empresa, tipo_agenda) => {
        const contaAtiva = await VerificaSituacaoConta(usu_ativa_conta);
    
        if (!contaAtiva) {
            return; // Se a conta não estiver ativa, não continuar
        }

        const empresaData = {
            id_empresa,
            nome_empresa,
            endereco_empresa,
            fone_empresa,
            tipo_agenda
        };
        navigate('/app/cliente/home/explorar/empresa', { state: empresaData });
    };

    const VerificaSituacaoConta = (usu_ativa_conta) => {
        // console.log('usu_ativa_conta ', usu_ativa_conta);
        return new Promise((resolve) => {
            if (!usu_ativa_conta || usu_ativa_conta === 0) {
                Swal.fire({
                    title: 'Ativação da Conta',
                    text: 'Para agendar um serviço no AgendeX, você precisa primeiro validar seu email. Deseja fazê-lo agora?',
                    icon: 'question',
                    confirmButtonColor: '#3085d6',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, validar!',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        carregaDados(user).then(() => {
                            resolve(false); // Após carregar os dados e enviar o código de validação, não prosseguir com o agendamento
                        });
                    } else {
                        resolve(false); // Se o usuário cancelar, não prosseguir com o agendamento
                    }
                });
            } else {
                resolve(true); // Conta está ativa, pode prosseguir
            }
        });
    };
    
    const carregaDados = async (idUsuario) => {
        setLoading(true);
        try {
            const response = await apiaxios.post('/usuario/perfilWeb', {
                id_usuario: idUsuario, // Usar idUsuario aqui
                tipo_app: 0
            });
            if (response.status === 200) {
                const data = response.data;
                if (data.retorno === 'OK') {
                    setNome(data.nome);
                    setEmail(data.email);
                    setUsu_ativa_conta(data.ativa_conta);
                    await generateValidationCode(data.email);
                } else {
                    Swal.fire('Erro', data.retorno, 'error');
                }
            } else {
                Swal.fire('Erro', 'Falha ao carregar seus dados. Tente novamente mais tarde.', 'error');
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    function generateCV() {
        return Math.floor(100000 + Math.random() * 900000).toString();
    }

    async function generateValidationCode(email) {

        if (!email) {
            setMensagem('Email não pode ficar em branco.');

            setTimeout(() => {
                setMensagem('');
            }, 7000);
            return;
        }

        setLoading(true);

        try {
            const data = await apifetch(`/usuario/ContaExistenteWeb?email=${email}&tipoApp=0`, {
                method: 'GET'
            });

            const validationCode = generateCV();

            await apifetch(`/usuario/validaEmail?nome=${data.nome}&email=${email}&codigo=${validationCode}`, {
                method: 'GET'
            });
    
            // After successful email check, navigate to the next screen
            navigate('/app/cliente/perfil/cv', { state: 
                { nome: nome, email: email, validationCode: validationCode, from: '/app/cliente/home/explorar' } });

        } catch (error) {
            // Trate o erro
            // setLoading(false);

            console.error('Fetch error:', error);
            if (error.message.includes('CORS policy')) {
                setMensagem('Erro de CORS. Verifique as configurações do servidor.');            
            } else if (error.message === 'Failed to fetch') {
                setMensagem('Erro de conexão. Verifique sua conexão com a internet e tente novamente.');            
            } else {
                setMensagem(error.message);
            }

            setTimeout(() => {
                setMensagem('');
            }, 7000);
        } finally {
            setLoading(false);
        }
    }

    
    
    return (
        <>
            <div className="container-fluid">
                <div className="row flex-nowrap">
                    <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                        <Menu page="explorar"/>
                    </div>
                    <div className="col py-3 me-3 text-center">
                        <BuscaEmpresa onEmpresaPesquisada={setEmpresa}/>
                        <h1>Explorar</h1>
                        <h4>Serviço</h4>
                        {loading && (
                            <div className="loading-spinner-container">
                                <Oval color="#00BFFF" height={80} width={80} />
                            </div>
                        )}
                        {nenhumaEmpresaEncontrada ? (
                            <div className="alert alert-danger mt-2" role="alert">
                                Nenhuma "Empresa" disponível neste momento pra esta cidade...
                            </div>
                        ) : (
                            <div className="box-explorarempresas">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Foto Mini</th>
                                            <th>Nome Empresa</th>
                                            <th>Endereço</th>
                                            <th>Fone</th>
                                            <th className="text-right">Avaliação</th>
                                            <th></th>
                                        </tr>
                                    </thead>  
                                    <tbody>
                                        {dados.map((dados) => (
                                            <tr key={dados.ID_EMPRESA}>
                                                <td data-label="Foto Mini:">
                                                    {dados.foto64mini ? (
                                                        <img src={dados.foto64mini} alt={dados.NOME} height="84" width="56" />
                                                    ) : (
                                                        'Sem Foto'
                                                    )}
                                                </td>
                                                <td data-label="Nome Empresa">{dados.NOME}</td>
                                                <td data-label="Endereço:">{dados.ENDERECO} - {dados.BAIRRO} - {dados.CIDADE}</td>
                                                <td data-label="Fone:">{dados.FONE}</td>
                                                <td data-label="Avaliação: " className="rating-cell">
                                                    {dados.AVALIACAO_MEDIA !== undefined ? (
                                                        <img src={getStarImage(dados.AVALIACAO_MEDIA)} alt={`${dados.AVALIACAO_MEDIA} stars`} />
                                                    ) : 'N/A'}
                                                    {'(' + (dados.AVALIACAO_TOTAL !== undefined ? dados.AVALIACAO_TOTAL : 'N/A') + ')'}
                                                </td>
                                                <td>
                                                    <button
                                                        className="btn btn-info ml-10"
                                                        onClick={() => 
                                                            CarregaEmpresa(
                                                            dados.ID_EMPRESA,
                                                            dados.NOME,
                                                            `${dados.ENDERECO} - ${dados.BAIRRO} - ${dados.CIDADE}`,
                                                            dados.FONE, 
                                                            dados.USU_TIPO_AGENDA 
                                                                !== null && dados.USU_TIPO_AGENDA 
                                                                !== undefined 
                                                                    ? dados.USU_TIPO_AGENDA
                                                                    : 0
                                                        )}
                                                    >
                                                        <i className="bi bi-calendar-plus-fill"></i> Agendar
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    );
}

export default ExplorarEmpresas;